export function findGetParameter(parameterName = 'search'): string {
  const url = new URL(window.location.href);

  return url.searchParams.get(parameterName) || '';
}

export function findAllGetParameters(parameterName: string): string[] {
  const url = new URL(window.location.href);

  return url.searchParams.getAll(parameterName);
}

export function findGetFilter(
  parameterName = 'pimId',
): { pimId: number; depth: number } | undefined {
  const searchParamValue = new URLSearchParams(window.location.search).getAll(parameterName)[0];

  if (!searchParamValue) {
    return undefined;
  }

  return {
    pimId: parseInt(searchParamValue, 10),
    depth: parseInt(parameterName.split('-')[1], 10),
  };
}
